import { render, staticRenderFns } from "./AssessmentEduData.vue?vue&type=template&id=17e508c6&scoped=true"
import script from "./AssessmentEduData.vue?vue&type=script&lang=js"
export * from "./AssessmentEduData.vue?vue&type=script&lang=js"
import style0 from "./AssessmentEduData.vue?vue&type=style&index=0&id=17e508c6&prod&scoped=true&lang=css"
import style1 from "./AssessmentEduData.vue?vue&type=style&index=1&id=17e508c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e508c6",
  null
  
)

export default component.exports